import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { classLeaderboardsCrudStateConfig } from "../../consts";

export type ClassLeaderboardsMetaStateSliceType = {
  classLeaderboards: CrudBuilderState | Map<any, any>;
};

const classMetaInitialState = makeCrudBuilderInitialState(
  classLeaderboardsCrudStateConfig
);

const defaultClassLeaderboardsMetaStateSlice: ClassLeaderboardsMetaStateSliceType =
  {
    classLeaderboards: classMetaInitialState
  };

export default class ClassLeaderboardsMetaStateSlice extends Record(
  defaultClassLeaderboardsMetaStateSlice
) {}
